import { render, staticRenderFns } from "./ProductSalesManagement.vue?vue&type=template&id=46da85f0&scoped=true&"
import script from "./ProductSalesManagement.vue?vue&type=script&lang=js&"
export * from "./ProductSalesManagement.vue?vue&type=script&lang=js&"
import style0 from "./ProductSalesManagement.vue?vue&type=style&index=0&id=46da85f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46da85f0",
  null
  
)

export default component.exports